import React, {FC, useRef} from "react";
import BTooltip from "../b-tooltip";
import Popup from 'reactjs-popup';
import QRCode from "react-qr-code";

interface BQRData {
    value: string | number,
    header?: any,
}

const BQR: FC<BQRData> = (props) => {
    const ref = useRef();

    // @ts-ignore
    return <Popup modal ref={ref}
                  className="bs-modal"
                  trigger={<span><BTooltip text="Click to view QR code">&nbsp;<i className="bi bi-qr-code-scan bs-copy"></i></BTooltip></span>}>
        <div className="bs-card bs-qr-code">
            <div className="bs-card-header">
                {/*@ts-ignore*/}
                <h4 className="bs-card-header-title">Address QR Code <i className="bi bi-x-lg" onClick={() => ref.current.close()}></i></h4>
            </div>
            <div className="bs-card-body">
                <div className="bs-qr-code-box">
                    {/*@ts-ignore*/}
                    <QRCode value={props?.value}/>
                    <p>{props?.value}</p>
                </div>
            </div>
        </div>
    </Popup>
};

export default BQR;
